var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgRdatapDocument = function SvgRdatapDocument(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "562.313 207.192 22.581 25.568"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M573.094 207.696l11.261 11.087c.72.708.72 1.652 0 2.36l-11.26 11.086c-.719.708-1.678.708-2.396 0l-7.667-7.548c-.24-.236-.479-.708-.479-.944l-.24-3.302v-3.539c0-.472.24-.943.48-1.18l7.906-7.784c.718-.943 1.916-.943 2.395-.236zm7.907 12.267l-9.104-8.964-6.23 6.133v2.83l.24 2.596 6.23 6.133 8.864-8.728z",
    fill: "#F3A685"
  })));
};
export default SvgRdatapDocument;